module.exports = __webpack_public_path__ + "static/media/TOTAL-SCORE-2.f6ff78fb.png";